'use strict';

var _require = require('base/product/detail'),
  updateAddToCart = _require.updateAddToCart;
module.exports = {
  updateAttributes: function updateAttributes() {
    $('body').on('product:statusUpdate', function (e, data) {
      var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');
      $productContainer.find('.main-content-group .product-attributes').empty().html(data.attributesHtml);
      $('body').trigger('tooltip:init');
      updateAddToCart();
    });
  },
  updateAddAllToCart: function updateAddAllToCart() {
    // if default variants are selected, enable the add all to cart btn on load
    var enable = $('.product-availability').toArray().every(function (item) {
      return $(item).data('available') && $(item).data('ready-to-order');
    });
    $('button.add-to-cart-global').attr('disabled', !enable);
  },
  copyProductLink: function copyProductLink() {
    $('body').on('click', '#fa-link', function () {
      event.preventDefault();
      var $temp = $('<input>');
      $('body').append($temp);
      $temp.val($('#shareUrl').val()).select();
      document.execCommand('copy');
      $temp.remove();
      $('.copy-link-message').attr('role', 'alert');
      $('.copy-link-message').removeClass('d-none');
      setTimeout(function () {
        $('.copy-link-message').addClass('d-none');
      }, 3000);
    });
  },
  showSpinner: function showSpinner() {
    $('body').on('product:beforeAddToCart, product:beforeAttributeSelect', function () {
      $.spinner().start();
    });
  },
  setCollapsibleContentState: function setCollapsibleContentState() {
    var $collapsibleContentGroup = $('.collapsible-content-group');
    $collapsibleContentGroup.each(function () {
      var expandCollapsibleContentGroup = $(this).data('expand');
      if (expandCollapsibleContentGroup == true) {
        $(this).addClass('active');
      }
    });
  }
};